import { LayoutGrid } from "lucide-react";

/**
 * Sidebar / module icon. Renders the section's uploaded icon (managed from the
 * admin panel) when present, otherwise a neutral default glyph. Sized by its
 * container (fills width/height), so callers control the box.
 */
export function NavIcon({ src }: { src?: string | null }) {
  if (src) {
    return (
      <img
        src={src}
        alt=""
        className="h-full w-full object-contain"
        loading="lazy"
      />
    );
  }
  return <LayoutGrid className="h-full w-full" />;
}
